function getSavePostingState(state) {
  return {
    saving: state.savePostingProf.saving,
    triggerSource: state.savePostingProf.triggerSource,
    errorOnSave: state.savePostingProf.errorOnSave,
    errorOnSaveMessage: state.savePostingProf.errorOnSaveMessage,
    successOnSave: state.savePostingProf.successOnSave,
    postingId: state.savePostingProf.postingId
  };
}

export { getSavePostingState };
